import React, { Component } from 'react';
import AppLayout from '../../../layouts/AppLayout';
import AudienceContainer from '../../containers/performance/AudienceContainer';
import HeaderSelect from '../../containers/headerSelect/headerSelect';

export class Audience extends Component {
  render() {
    return (
      <AppLayout>
        <HeaderSelect />
        <AudienceContainer />
      </AppLayout>
    );
  }
}

export default Audience;
